import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateDirective } from "@ngx-translate/core";
import { NgbCollapse } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-produktionsmall-accordion",
    templateUrl: "./produktionsmall-accordion.component.html",
    styleUrls: ["./produktionsmall-accordion.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        TranslateDirective,
        NgbCollapse
    ]
})

export class ProduktionsmallAccordionComponent {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("headerText") set headerInput(val: string) { this.header = val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("isDefaultExpanded") set isDefaultExpanded(val: boolean) { this.isCollapsed = !val; }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("faIconClass") set icon(val: string) { this.faIconClass = val; }
    @Output() accordionActive: EventEmitter<boolean> = new EventEmitter<boolean>();

    header: string;
    badge = "";
    isCollapsed: boolean;
    isWarning: boolean;
    warning: string;
    faIconClass: string;

    toggle() {
        this.isCollapsed = !this.isCollapsed;
        this.accordionActive.emit(!this.isCollapsed);
    }

    displayCounter(count) {
        this.badge = count;
    }

}
